import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemStyle } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link/Link";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import HPPRewardsIcon from "@NA/Icons/HPPRewardsIcon";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { checkVaildUserForHmiRewards, convertPercentage, fomratLoyaltyPoints, remainingSpendGoal } from "@NA/Utils/Utility";
import CircularProgressBar from "@NA/Widgets/LoyaltyRewards/CircularProgressBar";
import { connect, ResolveThunks, useDispatch, useSelector } from "react-redux";
import React, { FC } from "react";
import { css } from "styled-components";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";

const enum fields {
    title = "title",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
    };
}
const mapStateToProps = (state: CustomApplicationState) => ({
    session: state.context.session,
});

interface ADIHPPProRewardsStyles {
    loyaltyValueTextpercentage?: InjectableCss;
    loyaltyTotalSpend?: InjectableCss;
    loyaltyLabelText?: InjectableCss;
    loyaltyValueText?: InjectableCss;
    loyaltyRemainingSpend?: InjectableCss;
    progressBarModel?: InjectableCss;
    circularProgressBarModal?: InjectableCss;
    circularProgressBar?: InjectableCss;
    GridItem?: InjectableCss;
    loyaltyLabelTextModal?: InjectableCss;
    loyaltyValueTextModal?: InjectableCss;
    loyaltygoalValueTextModal?: InjectableCss;
    leftColumnModalGrid?: InjectableCss;
    leftColumnModal?: InjectableCss;
    HPPContentGridItemnone?: InjectableCss;
    HPPGridContainer?: InjectableCss;
    HPPGridCard?: InjectableCss;
    HPPTitleCardContainer?: InjectableCss;
    HPPTitle?: InjectableCss;
    HPPContentCardContainer?: InjectableCss;
    HPPContentTitle?: InjectableCss;
    HPPContentDescription?: InjectableCss;
    HPPBtnStyle?: InjectableCss;
    HPPBtnGriditem?: InjectableCss;
    HPPContentGridItem?: InjectableCss;
    HPPTittleGridItem?: InjectableCss;
    HPPContentGridContainer?: InjectableCss;
    HPPProgresstoGoal?: InjectableCss;
    HPPSeedetails?: InjectableCss;
}


const ADIHPProRewardsStyles: ADIHPPProRewardsStyles = {

    HPPGridContainer: {
        css: css`
            margin:0 auto;
            padding: 15px 0;
            gap:20px;
            display:flex;
            flex: 1;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction:column;
                    `,
                    css`
                        flex-direction:column;
                    `,
                    null,
                    null,
                    null,
                ])}
                ${GridWrapper} {
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                                max-width:100%;
                            `,
                    null,
                    null,
                ])}
                } 
        `,
    },
    HPPGridCard: {
        css: css`
        flex:1;
        min-height:388px;
        border-radius: 6px;
        background-color: #fff;
        ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`min-height:auto;`,
                    css`min-height:auto;`,
                    css`min-height:auto;`,
                    null,
                    null,
                ])}  
        > ${GridOffset} {
         width:100%;
         margin:0px;
         height: 100%;
        }
    `,
    },
    HPPTitleCardContainer: {
        css: css`
        border-radius: 6px;
        border-bottom-left-radius:0px;
        border-bottom-right-radius:0px;
        padding: 15px 20px !important;
        background-color: #006892;
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        > svg {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width:28px;
                        height:28px;
                    `,
                    css`
                        width:28px;
                        height:28px;
                    `,
                    null,
                    null,
                    null,
                ])}
        }
    `,
    },
    HPPTitle: {
        css: css`
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        color: #fff;
        margin-left:10px;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    font-size: 16px;
                `,
                    css`
                    font-size: 16px;
                `,
                    css`
                    font-size: 18px;
                `,
                    null,
                    null,
                ])}
    `,
    },
    HPPContentCardContainer: {
        css: css`
        padding:15px 20px 20px;
        height:calc(100% - 65px);
        border-radius: 6px;
        border: solid 1px #bbb;
        border-top-left-radius:0px;
        border-top-right-radius:0px;
        border-top:none;
        display: flex;
        flex-direction: column;
        justify-content:flex-start;
        align-items: flex-start;
        width: 100%;
        margin: 0 auto;
    `,
    },
    HPPContentGridContainer: {
        css: css`
        > ${GridOffset} {
         width:100%;
         margin:0px;
         height: 100%;
         display: flex;
        flex-direction: column;
            ${GridItemStyle}{
                max-width: 100%;
                width:100%;
                padding: 0px;
                flex-basis:initial;
                flex-direction: column;
            }
        }   
    `,
    },
    HPPTittleGridItem: {
        css: css`
               
    `,
    },
    HPPContentTitle: {
        css: css`
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        color: #2d2926;
        margin-bottom:5px;
        display: block;
         ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    font-size: 16px;
                `,
                    css`
                    font-size: 16px;
                `,
                    css`
                    font-size: 18px;
                `,
                    null,
                    null,
                ])}
    `,
    },
    HPPContentDescription: {
        css: css`
        font-size: 12px;
        font-weight: normal;
        line-height: normal;
        color: #2d2926;
        margin-bottom:10px;
        display: block;
    `,
    },
    HPPContentGridItem: {
        css: css`           
        flex:1 !important;
        margin-top:10px !important;
        margin-bottom:15px !important;
        padding: 0 0 5px;
        border-radius: 4px;
        background-image: linear-gradient(to bottom, #fff, #e9eff6 200%);
        justify-content: center;
        align-items: center;
    `,
    },
    HPPBtnGriditem: {
        css: css`
        
        display: flex;
        width:100%;
    `,
    },
    HPPBtnStyle: {
        css: css`
        padding: 10px;
        border-radius: 4px;
        border: solid 1px #004da6;
        background-color: #fff;
        width: 100%;
        color: #004da6;
            font-size: 16px;
            font-weight: bold;
            text-align: center;
            width: 100%;
            justify-content: center;
            min-height: 40px;
            line-height: 1;
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    font-size: 14px;
                `,
                    css`
                    font-size: 14px;
                `,
                    null,
                    null,
                    null,
                ])}
        &:hover {
                background-color: #c8ddf6;
        }
    `,
    },
    HPPContentGridItemnone: {
        css: css`display:none;`,

    },
    HPPSeedetails: {
        css: css`
        font-size: 14px;
        font-weight: bold;
        line-height: normal;
        color: #006ae3;
        text-align:center;
        margin: 5px 0px;
        cursor:pointer;
        &:hover {
            ${TypographyStyle}{
                color: #006ae3;
                text-decoration: underline;
            }
        }
        `,
    },
    HPPProgresstoGoal: {
        css: css`
            
        font-size: 16px;
        font-weight: bold;
        line-height: 1.63;
        color: #002856;
        text-align:center;
        margin-bottom:5px;
            `,
    },
    leftColumnModal: {
        css: css`             
           >  ${GridOffset} {
            width: 100%;
            margin: 0px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;                   
            > ${GridItemStyle} {
                justify-content: center;
                display: flex;
                flex-direction: column;
                align-items: center;
                position:relative;
                &:first-child{
                    max-width:140px;
                    text-align:center;
                    > ${GridItemStyle} {
                        width: 100%;
                        max-width: 100%;
                        padding: 0;
                        &:first-child{
                            > ${TypographyStyle} {
                                color: #2D2926;
                                text-align: center;
                                line-height: normal;
    
                                &:first-child{
                                    font-size: 11px;
                                    font-weight: 400;
                                    margin-bottom: 3px;    
                                }
                                &:last-child{
                                    font-size: 16px;
                                    font-weight: 700;
                                    margin-bottom: 9px;    
                                    line-height: normal;
                                }
                            }    
                        }
                        &:last-child{
                            > ${TypographyStyle} {
                                color: #666;
                                text-align: center;
                                line-height: normal;
                                
                                &:first-child{
                                    font-size: 11px;
                                    font-weight: 400;
                                    margin-bottom: 3px; 
                                }
                                &:last-child{
                                    margin-bottom: 0px;    
                                    line-height: normal;
                                    font-size: 16px;
                                    font-weight: 700;
                                }
                            }
    
                        }
    
                    }
                }
                &:last-child{
                    max-width:160px;
                }
                
                
            }
            }
        `,
    },
    leftColumnModalGrid: {
        css: css`
        max-width:110px;
        padding:0px;
        `,
    },
    loyaltyTotalSpend: {
        css: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom:20px;
        ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css` flex-basis: 40%;
            text-align: center;
            margin-bottom:0px; `,], "max",);
            }} 
        
        `,
    },
    loyaltyRemainingSpend: {
        css: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        
        ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css` flex-basis: 60%;               
                    text-align: center;`,], "max",);
            }} 
        `,
    },
    loyaltyLabelText: {
        css: css`
        font-size: 11px;
        font-weight: 400;
        `,
    },
    loyaltyValueText: {
        css: css`
        font-size: 11px;
        font-weight: 400;
        `,
    },
    loyaltyValueTextpercentage: {
        css: css`
        &:after{
            content: '%';
            font-size: 16px;
            font-weight: 400;
        }
        `,
    },
    progressBarModel: {
        css: css`
       width:110px;
       height:110px;
       ${GridItemStyle}  {
            position: absolute;                          
            top: 20px;
            padding: 10px 0px;
       }
    `,
    },
    circularProgressBarModal: {
        css: css`
            position: absolute;
            text-align: center;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width:110px;
            height:110px;
            .layaltyRewards{
                width:110px;
                height:110px;
            }
        `,
    },
    circularProgressBar: {
        css: css`
            position: absolute;
            text-align: center;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        `,
    },
    GridItem: {
        css: css`
        display: block;
        width: 100%;
        position: relative;
        
        
        > ${TypographyStyle} {
            display: block;
            width: 100%;
            text-align:center;
        }
        `,
    },
    loyaltyLabelTextModal: {
        css: css`
        font-size: 11px;
        font-weight: 400;
        text-align: center;           
        `,
    },
    loyaltyValueTextModal: {
        css: css`
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 5px;
        `,
    },

};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;


const ADIHPProRewards: FC<Props> = ({ fields }) => {

    const dispatch = useDispatch();
    const handleScrollToRewards = () => {

        if (window.location.pathname != "/myaccount") {
            dispatch({
                type: "AccountPage/RouteUpdate",
            });
        } else {
            handleScrollToRewardsView();
        }

    };
    const handleScrollToRewardsView = () => {
        const element = document.querySelector('[data-test-selector="rewards"]');
        const elementHeader = document.querySelector('[data-test-selector="header"]');
        if (element && elementHeader) {
            const elementRect = element.getBoundingClientRect();
            const elementRectHeader = elementHeader.getBoundingClientRect();
            setTimeout(() => {
                window.scrollTo({
                    top: elementRect.top + window.scrollY - elementRectHeader.height - 20,
                    behavior: "smooth",
                });
            }, 20);
        }
    };
    const styles = ADIHPProRewardsStyles;
    const loyaltyState = useSelector((state: CustomApplicationState) => state.ADIGlobalData.loyaltyRewardStore.loyalty);
    const userRoles = useSelector((state: CustomApplicationState) => state.context.session.userRoles);
    const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");
    const currentCurrencySymbol = useSelector(
        (state: CustomApplicationState) => state.context.session.currency?.currencySymbol,
    );
    const loadingSpinner = useSelector(
        (state: CustomApplicationState) => state?.ADIGlobalData?.loyaltyRewardStore.isLoading,
    );
    const progressValue = convertPercentage(loyaltyState.currentPercentToGoal);
    const isValidHmiUser = checkVaildUserForHmiRewards(loyaltyState);

    return (
        <>
            {(isProRewardsUser && loadingSpinner) ? (
                <LoadingSpinner size={15} style={{ position: "absolute", right: "50%", top: "50%" }} />
            ) : (
                <>
                    {
                        <>
                            {isProRewardsUser && isValidHmiUser &&
                                <StyledWrapper {...styles.HPPGridContainer}>
                                    <GridContainer {...styles.HPPGridCard}>
                                        <GridItem width={[12]} {...styles.HPPTitleCardContainer}>
                                            <HPPRewardsIcon />
                                            <Typography {...styles.HPPTitle}>{fields.title}</Typography>
                                        </GridItem>
                                        <GridItem width={[12]} {...styles.HPPContentCardContainer}>
                                            <GridContainer {...styles.HPPContentGridContainer}>
                                                <GridItem {...styles.HPPTittleGridItem}>
                                                    <Typography {...styles.HPPContentTitle}>Current Quarter Overview</Typography>
                                                    <Typography {...styles.HPPContentDescription}> {loyaltyState && loyaltyState.rewardsQuarter}</Typography>
                                                </GridItem>
                                                <GridItem {...styles.HPPContentGridItem}>

                                                    <Typography {...styles.HPPProgresstoGoal}>Progress To Goal</Typography>

                                                    <GridItem>
                                                        <GridContainer
                                                            {...styles.leftColumnModal}
                                                        >
                                                            <GridItem

                                                                {...styles.leftColumnModalGrid}
                                                            >
                                                                <GridItem {...styles.loyaltyTotalSpend}>
                                                                    <Typography {...styles.loyaltyLabelText}>
                                                                        {" "}
                                                                        {translate("Total ADI Spend")}
                                                                    </Typography>
                                                                    <Typography {...styles.loyaltyValueText}>
                                                                        {" "}
                                                                        {loyaltyState &&
                                                                            fomratLoyaltyPoints(
                                                                                loyaltyState.currentPurchases,
                                                                                currentCurrencySymbol,
                                                                            )}
                                                                    </Typography>
                                                                </GridItem>
                                                                <GridItem {...styles.loyaltyRemainingSpend}>
                                                                    <Typography {...styles.loyaltyLabelText}>
                                                                        {" "}
                                                                        {translate("Remaining Spend to Goal*")}
                                                                    </Typography>
                                                                    <Typography {...styles.loyaltyValueText}>
                                                                        {" "}
                                                                        {loyaltyState &&
                                                                            remainingSpendGoal(
                                                                                loyaltyState.currentGoal,
                                                                                loyaltyState.currentPurchases,
                                                                                currentCurrencySymbol,
                                                                            )}
                                                                    </Typography>
                                                                </GridItem>
                                                            </GridItem>
                                                            <GridItem
                                                                {...styles.progressBarModel}
                                                                width={[12, 12, 5, 6, 6]}
                                                            >
                                                                <StyledWrapper
                                                                    {...styles.circularProgressBarModal}
                                                                >
                                                                    <CircularProgressBar ProgressValue={progressValue} />
                                                                </StyledWrapper>
                                                                <GridItem

                                                                    {...styles.GridItem}
                                                                >
                                                                    <Typography
                                                                        {...styles.loyaltyLabelTextModal}
                                                                    >
                                                                        {" "}
                                                                        {translate("Goal")}
                                                                    </Typography>
                                                                    <Typography
                                                                        {...styles.loyaltyValueTextModal}
                                                                    >
                                                                        {loyaltyState &&
                                                                            fomratLoyaltyPoints(
                                                                                loyaltyState.currentGoal,
                                                                                currentCurrencySymbol,
                                                                            )}
                                                                    </Typography>
                                                                    <Typography
                                                                        {...styles.loyaltyLabelTextModal}
                                                                    >
                                                                        {" "}
                                                                        {translate("% to Goal")}
                                                                    </Typography>
                                                                    <Typography
                                                                        {...styles.loyaltyValueText}
                                                                        {...styles.loyaltyValueTextpercentage}
                                                                    >
                                                                        {" "}
                                                                        {convertPercentage(progressValue.toString())}
                                                                    </Typography>
                                                                </GridItem>
                                                            </GridItem>
                                                        </GridContainer>
                                                    </GridItem>

                                                    <Link {...styles.HPPSeedetails} href="/myaccount"
                                                        onClick={handleScrollToRewards}>See Details</Link>

                                                </GridItem>
                                                <GridItem {...styles.HPPBtnGriditem}>
                                                    <Clickable {...styles.HPPBtnStyle} href="/api/v1/singlesignon/signin" target="_blank" data-ga-promo="ADI-loyalty_Browse-Redeem">
                                                        {translate("Browse and Redeem")}
                                                    </Clickable>
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>
                                    </GridContainer>
                                </StyledWrapper>
                            }
                        </>
                    }
                </>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ADIHPProRewards),
    definition: {
        group: "Common",
        displayName: "My ADI Pro Rewards",
        fieldDefinitions: [
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "My ADI Pro Rewards",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
